// Auto-generated by temp/generate_season_anchors.py
export const SEASON_ANCHORS = [
  { date: '2025-03-20', term: 'spring' },
  { date: '2025-06-21', term: 'summer' },
  { date: '2025-09-23', term: 'autumn' },
  { date: '2025-12-21', term: 'winter' },
  { date: '2026-03-20', term: 'spring' },
  { date: '2026-06-21', term: 'summer' },
  { date: '2026-09-23', term: 'autumn' },
  { date: '2026-12-22', term: 'winter' },
  { date: '2027-03-21', term: 'spring' },
  { date: '2027-06-21', term: 'summer' },
  { date: '2027-09-23', term: 'autumn' },
  { date: '2027-12-22', term: 'winter' },
  { date: '2028-03-20', term: 'spring' },
  { date: '2028-06-21', term: 'summer' },
  { date: '2028-09-22', term: 'autumn' },
  { date: '2028-12-21', term: 'winter' },
  { date: '2029-03-20', term: 'spring' },
  { date: '2029-06-21', term: 'summer' },
  { date: '2029-09-23', term: 'autumn' },
  { date: '2029-12-21', term: 'winter' },
  { date: '2030-03-20', term: 'spring' },
  { date: '2030-06-21', term: 'summer' },
  { date: '2030-09-23', term: 'autumn' },
  { date: '2030-12-22', term: 'winter' },
  { date: '2031-03-21', term: 'spring' },
  { date: '2031-06-21', term: 'summer' },
  { date: '2031-09-23', term: 'autumn' },
  { date: '2031-12-22', term: 'winter' },
  { date: '2032-03-20', term: 'spring' },
  { date: '2032-06-21', term: 'summer' },
  { date: '2032-09-22', term: 'autumn' },
  { date: '2032-12-21', term: 'winter' },
  { date: '2033-03-20', term: 'spring' },
  { date: '2033-06-21', term: 'summer' },
  { date: '2033-09-23', term: 'autumn' },
  { date: '2033-12-21', term: 'winter' },
  { date: '2034-03-20', term: 'spring' },
  { date: '2034-06-21', term: 'summer' },
  { date: '2034-09-23', term: 'autumn' },
  { date: '2034-12-22', term: 'winter' },
  { date: '2035-03-21', term: 'spring' },
  { date: '2035-06-21', term: 'summer' },
  { date: '2035-09-23', term: 'autumn' },
  { date: '2035-12-22', term: 'winter' },
  { date: '2036-03-20', term: 'spring' },
  { date: '2036-06-21', term: 'summer' },
  { date: '2036-09-22', term: 'autumn' },
  { date: '2036-12-21', term: 'winter' },
  { date: '2037-03-20', term: 'spring' },
  { date: '2037-06-21', term: 'summer' },
  { date: '2037-09-23', term: 'autumn' },
  { date: '2037-12-21', term: 'winter' },
  { date: '2038-03-20', term: 'spring' },
  { date: '2038-06-21', term: 'summer' },
  { date: '2038-09-23', term: 'autumn' },
  { date: '2038-12-22', term: 'winter' },
  { date: '2039-03-21', term: 'spring' },
  { date: '2039-06-21', term: 'summer' },
  { date: '2039-09-23', term: 'autumn' },
  { date: '2039-12-22', term: 'winter' },
  { date: '2040-03-20', term: 'spring' },
  { date: '2040-06-21', term: 'summer' },
  { date: '2040-09-22', term: 'autumn' },
  { date: '2040-12-21', term: 'winter' },
  { date: '2041-03-20', term: 'spring' },
  { date: '2041-06-21', term: 'summer' },
  { date: '2041-09-22', term: 'autumn' },
  { date: '2041-12-21', term: 'winter' },
  { date: '2042-03-20', term: 'spring' },
  { date: '2042-06-21', term: 'summer' },
  { date: '2042-09-23', term: 'autumn' },
  { date: '2042-12-22', term: 'winter' },
  { date: '2043-03-21', term: 'spring' },
  { date: '2043-06-21', term: 'summer' },
  { date: '2043-09-23', term: 'autumn' },
  { date: '2043-12-22', term: 'winter' },
  { date: '2044-03-20', term: 'spring' },
  { date: '2044-06-21', term: 'summer' },
  { date: '2044-09-22', term: 'autumn' },
  { date: '2044-12-21', term: 'winter' },
  { date: '2045-03-20', term: 'spring' },
  { date: '2045-06-21', term: 'summer' },
  { date: '2045-09-22', term: 'autumn' },
  { date: '2045-12-21', term: 'winter' },
  { date: '2046-03-20', term: 'spring' },
  { date: '2046-06-21', term: 'summer' },
  { date: '2046-09-23', term: 'autumn' },
  { date: '2046-12-22', term: 'winter' },
  { date: '2047-03-21', term: 'spring' },
  { date: '2047-06-21', term: 'summer' },
  { date: '2047-09-23', term: 'autumn' },
  { date: '2047-12-22', term: 'winter' },
  { date: '2048-03-20', term: 'spring' },
  { date: '2048-06-20', term: 'summer' },
  { date: '2048-09-22', term: 'autumn' },
  { date: '2048-12-21', term: 'winter' },
  { date: '2049-03-20', term: 'spring' },
  { date: '2049-06-21', term: 'summer' },
  { date: '2049-09-22', term: 'autumn' },
  { date: '2049-12-21', term: 'winter' },
  { date: '2050-03-20', term: 'spring' },
  { date: '2050-06-21', term: 'summer' },
  { date: '2050-09-23', term: 'autumn' },
  { date: '2050-12-22', term: 'winter' },
  { date: '2051-03-21', term: 'spring' },
  { date: '2051-06-21', term: 'summer' },
  { date: '2051-09-23', term: 'autumn' },
  { date: '2051-12-22', term: 'winter' },
  { date: '2052-03-20', term: 'spring' },
  { date: '2052-06-20', term: 'summer' },
  { date: '2052-09-22', term: 'autumn' },
  { date: '2052-12-21', term: 'winter' },
  { date: '2053-03-20', term: 'spring' },
  { date: '2053-06-21', term: 'summer' },
  { date: '2053-09-22', term: 'autumn' },
  { date: '2053-12-21', term: 'winter' },
  { date: '2054-03-20', term: 'spring' },
  { date: '2054-06-21', term: 'summer' },
  { date: '2054-09-23', term: 'autumn' },
  { date: '2054-12-22', term: 'winter' },
  { date: '2055-03-20', term: 'spring' },
  { date: '2055-06-21', term: 'summer' },
  { date: '2055-09-23', term: 'autumn' },
  { date: '2055-12-22', term: 'winter' },
  { date: '2056-03-20', term: 'spring' },
  { date: '2056-06-20', term: 'summer' },
  { date: '2056-09-22', term: 'autumn' },
  { date: '2056-12-21', term: 'winter' },
  { date: '2057-03-20', term: 'spring' },
  { date: '2057-06-21', term: 'summer' },
  { date: '2057-09-22', term: 'autumn' },
  { date: '2057-12-21', term: 'winter' },
  { date: '2058-03-20', term: 'spring' },
  { date: '2058-06-21', term: 'summer' },
  { date: '2058-09-23', term: 'autumn' },
  { date: '2058-12-21', term: 'winter' },
  { date: '2059-03-20', term: 'spring' },
  { date: '2059-06-21', term: 'summer' },
  { date: '2059-09-23', term: 'autumn' },
  { date: '2059-12-22', term: 'winter' },
  { date: '2060-03-20', term: 'spring' },
  { date: '2060-06-20', term: 'summer' },
  { date: '2060-09-22', term: 'autumn' },
  { date: '2060-12-21', term: 'winter' },
  { date: '2061-03-20', term: 'spring' },
  { date: '2061-06-21', term: 'summer' },
  { date: '2061-09-22', term: 'autumn' },
  { date: '2061-12-21', term: 'winter' },
  { date: '2062-03-20', term: 'spring' },
  { date: '2062-06-21', term: 'summer' },
  { date: '2062-09-23', term: 'autumn' },
  { date: '2062-12-21', term: 'winter' },
  { date: '2063-03-20', term: 'spring' },
  { date: '2063-06-21', term: 'summer' },
  { date: '2063-09-23', term: 'autumn' },
  { date: '2063-12-22', term: 'winter' },
  { date: '2064-03-20', term: 'spring' },
  { date: '2064-06-20', term: 'summer' },
  { date: '2064-09-22', term: 'autumn' },
  { date: '2064-12-21', term: 'winter' },
  { date: '2065-03-20', term: 'spring' },
  { date: '2065-06-21', term: 'summer' },
  { date: '2065-09-22', term: 'autumn' },
  { date: '2065-12-21', term: 'winter' },
  { date: '2066-03-20', term: 'spring' },
  { date: '2066-06-21', term: 'summer' },
  { date: '2066-09-23', term: 'autumn' },
  { date: '2066-12-21', term: 'winter' },
  { date: '2067-03-20', term: 'spring' },
  { date: '2067-06-21', term: 'summer' },
  { date: '2067-09-23', term: 'autumn' },
  { date: '2067-12-22', term: 'winter' },
  { date: '2068-03-20', term: 'spring' },
  { date: '2068-06-20', term: 'summer' },
  { date: '2068-09-22', term: 'autumn' },
  { date: '2068-12-21', term: 'winter' },
  { date: '2069-03-20', term: 'spring' },
  { date: '2069-06-21', term: 'summer' },
  { date: '2069-09-22', term: 'autumn' },
  { date: '2069-12-21', term: 'winter' },
  { date: '2070-03-20', term: 'spring' },
  { date: '2070-06-21', term: 'summer' },
  { date: '2070-09-22', term: 'autumn' },
  { date: '2070-12-21', term: 'winter' },
  { date: '2071-03-20', term: 'spring' },
  { date: '2071-06-21', term: 'summer' },
  { date: '2071-09-23', term: 'autumn' },
  { date: '2071-12-22', term: 'winter' },
  { date: '2072-03-20', term: 'spring' },
  { date: '2072-06-20', term: 'summer' },
  { date: '2072-09-22', term: 'autumn' },
  { date: '2072-12-21', term: 'winter' },
  { date: '2073-03-20', term: 'spring' },
  { date: '2073-06-21', term: 'summer' },
  { date: '2073-09-22', term: 'autumn' },
  { date: '2073-12-21', term: 'winter' },
  { date: '2074-03-20', term: 'spring' },
  { date: '2074-06-21', term: 'summer' },
  { date: '2074-09-22', term: 'autumn' },
  { date: '2074-12-21', term: 'winter' },
  { date: '2075-03-20', term: 'spring' },
  { date: '2075-06-21', term: 'summer' },
  { date: '2075-09-23', term: 'autumn' },
  { date: '2075-12-22', term: 'winter' },
  { date: '2076-03-20', term: 'spring' },
  { date: '2076-06-20', term: 'summer' },
  { date: '2076-09-22', term: 'autumn' },
  { date: '2076-12-21', term: 'winter' },
  { date: '2077-03-20', term: 'spring' },
  { date: '2077-06-21', term: 'summer' },
  { date: '2077-09-22', term: 'autumn' },
  { date: '2077-12-21', term: 'winter' },
  { date: '2078-03-20', term: 'spring' },
  { date: '2078-06-21', term: 'summer' },
  { date: '2078-09-22', term: 'autumn' },
  { date: '2078-12-21', term: 'winter' },
  { date: '2079-03-20', term: 'spring' },
  { date: '2079-06-21', term: 'summer' },
  { date: '2079-09-23', term: 'autumn' },
  { date: '2079-12-22', term: 'winter' },
  { date: '2080-03-20', term: 'spring' },
  { date: '2080-06-20', term: 'summer' },
  { date: '2080-09-22', term: 'autumn' },
  { date: '2080-12-21', term: 'winter' },
  { date: '2081-03-20', term: 'spring' },
  { date: '2081-06-20', term: 'summer' },
  { date: '2081-09-22', term: 'autumn' },
  { date: '2081-12-21', term: 'winter' },
  { date: '2082-03-20', term: 'spring' },
  { date: '2082-06-21', term: 'summer' },
  { date: '2082-09-22', term: 'autumn' },
  { date: '2082-12-21', term: 'winter' },
  { date: '2083-03-20', term: 'spring' },
  { date: '2083-06-21', term: 'summer' },
  { date: '2083-09-23', term: 'autumn' },
  { date: '2083-12-22', term: 'winter' },
  { date: '2084-03-20', term: 'spring' },
  { date: '2084-06-20', term: 'summer' },
  { date: '2084-09-22', term: 'autumn' },
  { date: '2084-12-21', term: 'winter' },
  { date: '2085-03-20', term: 'spring' },
  { date: '2085-06-20', term: 'summer' },
  { date: '2085-09-22', term: 'autumn' },
  { date: '2085-12-21', term: 'winter' },
  { date: '2086-03-20', term: 'spring' },
  { date: '2086-06-21', term: 'summer' },
  { date: '2086-09-22', term: 'autumn' },
  { date: '2086-12-21', term: 'winter' },
  { date: '2087-03-20', term: 'spring' },
  { date: '2087-06-21', term: 'summer' },
  { date: '2087-09-23', term: 'autumn' },
  { date: '2087-12-22', term: 'winter' },
  { date: '2088-03-19', term: 'spring' },
  { date: '2088-06-20', term: 'summer' },
  { date: '2088-09-22', term: 'autumn' },
  { date: '2088-12-21', term: 'winter' },
  { date: '2089-03-20', term: 'spring' },
  { date: '2089-06-20', term: 'summer' },
  { date: '2089-09-22', term: 'autumn' },
  { date: '2089-12-21', term: 'winter' },
  { date: '2090-03-20', term: 'spring' },
  { date: '2090-06-21', term: 'summer' },
  { date: '2090-09-22', term: 'autumn' },
  { date: '2090-12-21', term: 'winter' },
  { date: '2091-03-20', term: 'spring' },
  { date: '2091-06-21', term: 'summer' },
  { date: '2091-09-23', term: 'autumn' },
  { date: '2091-12-21', term: 'winter' },
  { date: '2092-03-19', term: 'spring' },
  { date: '2092-06-20', term: 'summer' },
  { date: '2092-09-22', term: 'autumn' },
  { date: '2092-12-21', term: 'winter' },
  { date: '2093-03-20', term: 'spring' },
  { date: '2093-06-20', term: 'summer' },
  { date: '2093-09-22', term: 'autumn' },
  { date: '2093-12-21', term: 'winter' },
  { date: '2094-03-20', term: 'spring' },
  { date: '2094-06-21', term: 'summer' },
  { date: '2094-09-22', term: 'autumn' },
  { date: '2094-12-21', term: 'winter' },
  { date: '2095-03-20', term: 'spring' },
  { date: '2095-06-21', term: 'summer' },
  { date: '2095-09-23', term: 'autumn' },
  { date: '2095-12-21', term: 'winter' },
  { date: '2096-03-19', term: 'spring' },
  { date: '2096-06-20', term: 'summer' },
  { date: '2096-09-22', term: 'autumn' },
  { date: '2096-12-21', term: 'winter' },
  { date: '2097-03-20', term: 'spring' },
  { date: '2097-06-20', term: 'summer' },
  { date: '2097-09-22', term: 'autumn' },
  { date: '2097-12-21', term: 'winter' },
  { date: '2098-03-20', term: 'spring' },
  { date: '2098-06-21', term: 'summer' },
  { date: '2098-09-22', term: 'autumn' },
  { date: '2098-12-21', term: 'winter' },
  { date: '2099-03-20', term: 'spring' },
  { date: '2099-06-21', term: 'summer' },
  { date: '2099-09-23', term: 'autumn' },
  { date: '2099-12-21', term: 'winter' },
] as const;

export type SeasonAnchor = typeof SEASON_ANCHORS[number];
